export default __webpack_public_path__ + "static/media/news12.d824ea81.jpg";